export default __webpack_public_path__ + "static/media/profilePic-1.923f534b.jpg";